/** iOS WebKit: backdrop-filter nad <video> i natywny fullscreen omijają maskę CSS. */
export function isIOS() {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    return (
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
}

/** iOS rysuje maskę na canvasie-nakładce (backdrop-filter nad <video> nie działa). */
export function needsCanvasPrivacyMask() {
    return isIOS();
}

/**
 * Czy potrafimy wypalić maskę w piksele wideo w przeglądarce (wariant A).
 * Wymaga canvas.captureStream + odtwarzania MediaStream w <video>.
 * Na iOS zawodne (ograniczenia WebKit) — tam świadomie używamy wariantu B.
 */
export function canBakePrivacyInBrowser() {
    if (typeof document === 'undefined') return false;
    if (isIOS()) return false;
    const canvas = document.createElement('canvas');
    return typeof canvas.captureStream === 'function';
}

/**
 * Natywny fullscreen samego <video> gubi nakładkę DOM. Preferujemy fullscreen
 * kontenera (a gdy się nie da — pseudo-fullscreen CSS), żeby maska została.
 */
export function prefersStageFullscreen() {
    return true;
}

/** Czy przeglądarka ma natywny Fullscreen API na dowolnym elemencie (nie tylko <video>). */
export function supportsElementFullscreen(el) {
    if (!el) return false;
    return (
        typeof el.requestFullscreen === 'function' ||
        typeof el.webkitRequestFullscreen === 'function' ||
        typeof el.mozRequestFullScreen === 'function'
    );
}
